import { Controller } from '@hotwired/stimulus';
import { trackEvent } from '../analytics';

// Fires a conversion event across every platform (GA4, PostHog — see analytics.js).
// Fires on connect by default; set trigger-value (e.g. "click") and bind an action to fire on demand.
export default class extends Controller {
  static values = {
    event: String,
    params: Object,
    trigger: { type: String, default: 'connect' },
  };

  connect() {
    if (this.hasEventValue && this.triggerValue === 'connect') {
      this.track();
    }
  }

  track() {
    trackEvent(this.eventValue, this.hasParamsValue ? this.paramsValue : {});
  }
}
